<mat-card class="short-answer activities-card mat-elevation-z0" [ngClass]="{'two-columns-layout': isTwoColumns}">

  <mat-card-header>
    <mat-card-title>
      @if (isConsigneContainMedia(wording) || (!isDataEmpty(wording) && !isDataEmpty(wordingAudio)) || (!isDataEmpty(wording) && isDataEmpty(wordingAudio))) {
        <app-consignes
          class="centeredContent"
          [wording]="wording" [ngClass]="{'consigneImg': isWordingImg()}"
          [wordingAudio]="wordingAudio"
          [autoRead]="isAutoReadActive('wording')" [readable]="!isConsigneContainMedia(wording)" >
        </app-consignes>
      }
    </mat-card-title>
  </mat-card-header>

  <mat-card-content  [class.displayForSummary]="displayForSummary" [class.instruction-is-picture]="instruction?.includes('<img')" [ngClass]="reply?.state">
    @if (isConsigneContainMedia(instruction) || (!isDataEmpty(instruction) && !isDataEmpty(instructionAudio)) || (!isDataEmpty(instruction) && isDataEmpty(instructionAudio))) {
      <app-consignes
        [read]="readSecondConsigne"
        class="centeredContent"
        [class.isWordingImage]="isWordingImage"
        [instruction]="instruction" [ngClass]="{'consigneImg': isInstructionImg()}"
        [instructionAudio]="instructionAudio"
        [autoRead]="isAutoReadActive('instruction')" [readable]="!isConsigneContainMedia(instruction)"
        questionTypeName="{{ 'activities.questionTypeName.app-short-answer' | translate }}">
      </app-consignes>
    }

    @for (f of referenceActivityGranule?.flashcards; track f) {
      <app-flashcard [class.button-image]="f.image"
        [class.is-audio]="f.audio?.uri"
        [flashCard]="f">
      </app-flashcard>
    }

    @if (!isFormula) {
      <div class="textarea-wrapper">
        <textarea
          [disabled]="disable || isSaving || displaySolution || displayForSummary"
          class="responseTextarea"
          type="text"
          placeholder="{{'activities.placeholder_reply_here' | translate}}"
          [(ngModel)]="reply.answer"
          (ngModelChange)="onNgModelChange($event)">
        </textarea>
      </div>
    }

    @if (isPoll) {
      <app-poll [value]="reply.answer" [assignatedCount]="assignatedCount"
        (moveSlider)="onMoveSlider($event)"
      (clickSlider)="onClickSlider($event)"></app-poll>
    }

    @if (isFormula) {
      <div class="latex-wrapper longAnswer">
        <span class="correction" [ngClass]="answerState()"></span>
        @for (reference of generateArrayToIterateAndDisplayKeyboard; track reference) {
          <app-keyboard-latex-field
            [symbols]="symbols"
            [optionsFromSettings]="optionsFromSettings"
            [blacklistTabs]="blacklistTabs"
            [disable]="disable || displaySolution || displayForSummary"
            [displayForSummary]="displayForSummary"
            [displaySolution]="displaySolution"
            [answerCorrected]="answerCorrected"
            (clickAnswer)="validate()"
            (doesUserResponded)="doesUserResponded($event)"
            (onOptionChange)="onOptionChange($event)"
            (onKeyboardReady)="onKeyboardReady($event)"
          ></app-keyboard-latex-field>
        }
      </div>
    }
  </mat-card-content>

  @if (!isPoll && displayFeedback) {
    <div class="answer-state-msg wrongreply">
      <p>{{ 'activities.feedback.try_correct' | translate }}</p>
    </div>
  }

  <mat-card-footer>
    @if (isPercentileDisplayAllowed) {
      <div class="gradePercentil"
      >{{ 'generic.score' | translate}}{{showPercentile}}</div>
    }

    @if (!isActivityEmbeddedDone) {
      @for (button of buttons; track button) {
        @if (button.display) {
          <button
            [class]="getStateAnswer(button.type)"
            [disabled]="button.disable"
            (click)="onAction(button)">
            @if (button.svgIcon) {
              <mat-icon [svgIcon]="button.svgIcon"></mat-icon>
            }
            <span>{{ button.title | translate }}</span>
          </button>
        }
      }
    }
  </mat-card-footer>
</mat-card>
@if (!!feedbackFromApi && isActivityEmbeddedDone) {
  <app-activities-feedback
    (action)="actionFromFeedback($event)"
    [activityType]="activityType"
    [feedback]="feedbackFromApi"
    [buttons]="feedbackButtons"
    [answerStatus]="answerStatus">
  </app-activities-feedback>
}
@if (isLessonWithStep && isSaving) {
  <div fxFill fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
}